import { render, staticRenderFns } from "./ProductIntroductionTemplateEdit.vue?vue&type=template&id=f65f08f4&scoped=true"
import script from "./ProductIntroductionTemplateEdit.vue?vue&type=script&lang=js"
export * from "./ProductIntroductionTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductIntroductionTemplateEdit.vue?vue&type=style&index=0&id=f65f08f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65f08f4",
  null
  
)

export default component.exports